import React from 'react'
import { useStateContext } from '../context/StateContext'

export default function Graph() {
  const [state] = useStateContext()
  const type = state.adult ? 'adult' : 'child'

  let url = `/content/ccorg/us/en.bmi-${type}graph.png`

  if (process.env.NODE_ENV === 'development') {
    url = `http://localhost:4502/content/ccorg/us/en.bmi-${type}graph.png`
  }

  if (state.adult) {
    let feet = Math.floor(state.height / 12)
    let inches = state.height - feet * 12
    const pounds = state.weight > 360 ? 360 : state.weight

    if (feet >= 6 && inches > 9) {
      feet = 6
      inches = 9
    }

    url += `?feet=${feet}&inches=${inches}&pounds=${pounds}`
  } else {
    const bmi = state.bmi > 35 ? 35 : state.bmi.toFixed(1)
    const years = state.age > 18 ? 18 : state.age
    const months = 0

    url += `?bmi=${bmi}&years=${years}&months=${months}`
  }

  return (
    <div>
      <img className="graph" src={url} alt="graph" />
    </div>
  )
}
